<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
const props = defineProps({
  id: {
    type: String,
    default: '',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  additionalClasses: {
    type: Object,
    default: () => ({}),
  },
})

const id = computed(
  () => props.id || 'accordion-id-' + Math.round(Math.random() * 10000),
)
const accordionStore = useAccordionItems()

onBeforeMount(() => {
  accordionStore.registerAccordion(id.value, props.multiple)
})

provide('accordion', { id })
</script>

<template>
  <div
    class="accordion"
    :class="additionalClasses"
    :data-multi-expand="multiple"
    :data-allow-all-closed="true"
  >
    <slot></slot>
  </div>
</template>
